/* Palmekongen – moderne detaljer (okt 2026) */
(function () {
  function placerTryghed() {
    var tpl = document.getElementById('pk-tryghed-tpl');
    if (!tpl || document.querySelector('.pk-tryghed')) return;
    var main = document.getElementById('MainContent');
    var form = main && main.querySelector('product-form, .product-form');
    if (!form) return;
    var anchor = form.parentElement && form.parentElement.tagName === 'DIV' ? form.parentElement : form;
    anchor.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
  }

  function animer() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var kandidater = [].slice.call(main.querySelectorAll(':scope > .shopify-section'));
    var footer = document.querySelectorAll('.shopify-section-group-footer-group');
    kandidater = kandidater.concat([].slice.call(footer));
    var foldGraense = window.innerHeight * 0.9;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pk-reveal--synlig'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    kandidater.forEach(function (el) {
      if (el.getBoundingClientRect().top < foldGraense) return; // det, man ser med det samme, animeres ikke
      el.classList.add('pk-reveal');
      obs.observe(el);
    });
  }

  /* Plantestudiet: på forsiden flyttes videoerne op før kundeudtalelserne */
  function placerVideoer() {
    if (!document.body.classList.contains('template-index')) return;
    var ps = document.querySelector('.pk-plantestudie-section');
    var ref = document.querySelector('#MainContent [id$="__testimonials"]') || document.querySelector('#MainContent [id$="__reveal-banner"]');
    if (ps && ref) ref.parentNode.insertBefore(ps, ref);
  }

  /* Trustpilot: kundernes vurdering vist på produktsider og forsiden (tal opdateres manuelt) */
  var TP_URL = 'https://dk.trustpilot.com/review/palmekongen12.shop';
  var TP_SCORE = '4,6';
  var TP_ORD = 'Fremragende';
  var TP_CSS = '.pk-tp{display:inline-flex;align-items:center;gap:.8rem;margin:.6rem 0 1.4rem;color:#1a1b18;text-decoration:none;font-size:1.35rem;line-height:1.3}.pk-tp__stjerner{display:inline-flex;gap:.2rem}.pk-tp__stjerner svg{width:1.6rem;height:1.6rem;fill:#1a1b18}.pk-tp__tekst strong{font-weight:600}.pk-tp:hover .pk-tp__tekst{text-decoration:underline;text-underline-offset:.3rem}.pk-tp-wrap{text-align:center;padding-top:3.6rem}.pk-tp--stor{font-size:1.6rem;margin:0}.pk-tp--stor .pk-tp__stjerner svg{width:2rem;height:2rem;fill:#D9774A}@media screen and (max-width:480px){.pk-tp--stor{flex-direction:column;gap:.6rem}}';
  var STJERNE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z"/></svg>';
  function tpBadge(stor) {
    var a = document.createElement('a');
    a.className = 'pk-tp' + (stor ? ' pk-tp--stor' : '');
    a.href = TP_URL; a.target = '_blank'; a.rel = 'noopener';
    a.setAttribute('aria-label', 'Bedømt ' + TP_SCORE + ' ud af 5 på Trustpilot – ' + TP_ORD.toLowerCase());
    a.innerHTML = '<span class="pk-tp__stjerner">' + STJERNE + STJERNE + STJERNE + STJERNE + STJERNE + '</span>' +
      '<span class="pk-tp__tekst"><strong>' + TP_SCORE + ' ud af 5</strong> på Trustpilot · ' + TP_ORD + '</span>';
    return a;
  }
  function placerTrustpilot() {
    var main = document.getElementById('MainContent');
    if (!main || main.querySelector('.pk-tp')) return;
    var sat = false;
    if (document.body.classList.contains('template-product')) {
      var pris = main.querySelector('.product__info-container .price, .product__info-wrapper .price, .product .price');
      var anker = pris || main.querySelector('.product__title, h1');
      if (anker) { anker.insertAdjacentElement('afterend', tpBadge(false)); sat = true; }
    }
    if (document.body.classList.contains('template-index')) {
      var t = main.querySelector('[id$="__testimonials"]');
      if (t) { var w = document.createElement('div'); w.className = 'pk-tp-wrap page-width'; w.appendChild(tpBadge(true)); t.insertAdjacentElement('afterbegin', w); sat = true; }
    }
    if (sat) { var st = document.createElement('style'); st.textContent = TP_CSS; document.head.appendChild(st); }
  }

  /* Overskriftsskriften har et for bredt Ø: stram afstanden omkring Ø/ø i overskrifter */
  function stramOe() {
    var sel = 'h1, h2, h3, .h0, .h1, .h2, .h3, .title, .pk-budskab__linje, .pk-hero__heading';
    [].forEach.call(document.querySelectorAll(sel), function (el) {
      if (el.dataset.pkOe || !/[Øø]/.test(el.textContent)) return;
      el.dataset.pkOe = '1';
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), noder = [], n;
      while ((n = w.nextNode())) if (/[Øø]/.test(n.data)) noder.push(n);
      noder.forEach(function (t) {
        var frag = document.createDocumentFragment();
        t.data.split(/([Øø])/).forEach(function (del) {
          if (del === 'Ø' || del === 'ø') { var s = document.createElement('span'); s.className = 'pk-oe'; s.textContent = del; frag.appendChild(s); }
          else if (del) frag.appendChild(document.createTextNode(del));
        });
        t.parentNode.replaceChild(frag, t);
      });
    });
    if (!document.getElementById('pk-oe-css')) {
      var st = document.createElement('style'); st.id = 'pk-oe-css';
      st.textContent = '.pk-oe{margin:0 -.065em 0 -.06em}';
      document.head.appendChild(st);
    }
  }

  function start() { stramOe(); placerTryghed(); placerVideoer(); placerTrustpilot(); animer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
